import { useEffect } from "react";
import { getOgImageUrl, getSiteUrl } from "../utils/siteUrl";
import {
  ZAROR_OG_IMAGE_HEIGHT,
  ZAROR_OG_IMAGE_WIDTH
} from "../utils/brandAssets";

const SITE_TITLE = "Zaror Sports - Custom Teamwear & Kit Designer";
const SITE_DESCRIPTION =
  "Zaror Sports - Custom teamwear and kit designer. Design your own football, basketball, cricket, and hockey kits with professional colour options and customization.";

function setMetaTag(attribute, key, content) {
  if (!content) return;

  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

const SocialMetaUpdater = () => {
  useEffect(() => {
    const siteUrl = getSiteUrl();
    const ogImageUrl = getOgImageUrl();

    document.title = SITE_TITLE;
    setMetaTag("name", "description", SITE_DESCRIPTION);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:site_name", "Zaror Sports");
    setMetaTag("property", "og:title", SITE_TITLE);
    setMetaTag("property", "og:description", SITE_DESCRIPTION);
    setMetaTag("property", "og:url", `${siteUrl}/`);
    setMetaTag("property", "og:image", ogImageUrl);
    setMetaTag("property", "og:image:width", String(ZAROR_OG_IMAGE_WIDTH));
    setMetaTag("property", "og:image:height", String(ZAROR_OG_IMAGE_HEIGHT));
    setMetaTag("property", "og:image:type", "image/png");
    setMetaTag("property", "og:image:alt", "Zaror Sports logo");
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", SITE_TITLE);
    setMetaTag("name", "twitter:description", SITE_DESCRIPTION);
    setMetaTag("name", "twitter:image", ogImageUrl);
  }, []);

  return null;
};

export default SocialMetaUpdater;
